export default  [
    {
        path: 'tempo-espera',
        redirect: 'tempo-espera/index',
        component: () => import(
            /* webpackChunkName: 'painel-senha-tempo-espera' */
            '@/views/painel-senha/tempo-espera/Index'
        ),
        children: [
            {
                name: 'painel-senha-tempo-espera-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-tempo-espera-index' */
                    '@/views/painel-senha/tempo-espera/List'
                ),
            },
            {
                name: 'painel-senha-tempo-espera-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-tempo-espera-create' */
                    '@/views/painel-senha/tempo-espera/Form.vue'
                ),
            },
            {
                name: 'painel-senha-tempo-espera-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'painel-senha-tempo-espera-edit' */
                    '@/views/painel-senha/tempo-espera/Form.vue'
                ),
            },
        ],
    },
]